import { hamiVuex } from '@/store/base'
import { tokenStore } from '@/store/token'
import { API } from '@/plugins/api'

export const merchantStore = hamiVuex.store({
  $name: 'merchant',
  $state: {
    user: null,
    authorizeUrl: null,
  },
  setUser(user) {
    this.$patch({ user: user })
  },
  setAuthorizeUrl(url) {
    this.$patch({ authorizeUrl: url })
  },
  get isLogin() {
    return !!this.user
  },
  get isAdmin() {
    return !!this.user?.is_admin
  },
  get userId() {
    return this.user?.user_id
  },
  get username() {
    return this.user?.username
  },
  get merchantId() {
    return this.userId
  },
  async doCheckLogin() {
    if (this.isLogin) {
      return
    }
    tokenStore.loadToken()
    let result = await API.call('merchant/auth.check_login')
    if (result['is_login']) {
      if (result['token']) {
        tokenStore.setToken({ token: result['token'] })
      }
      merchantStore.setUser(result)
    }
    this.setAuthorizeUrl(result['authorize_url'])
  },
  async doLogout() {
    tokenStore.setToken({ token: null })
    window.location.assign('/dash/')
  },
})
